export function Footer() {
  return (
    <footer
      className="flex flex-col md:flex-row justify-between items-center gap-4 px-6 md:px-12 py-12 max-w-[1200px] mx-auto"
      style={{ borderTop: '1px solid #24201b' }}
    >
      <div>
        <div
          className="mb-2"
          style={{
            fontFamily: "'Cinzel', serif",
            fontSize: 16,
            fontWeight: 700,
            color: '#b5a99c',
            letterSpacing: '0.12em',
          }}
        >
          GALDORN
        </div>
        <div style={{ color: '#404e64', fontSize: 13 }}>
          &copy; {new Date().getFullYear()} Galdorn. All rights reserved.
        </div>
      </div>
      <div className="flex gap-6">
        {['Changelog', 'Privacy', 'Terms', 'Contact'].map((label) => (
          <a
            key={label}
            href="#"
            className="transition-colors hover:text-game-300"
            style={{ color: '#635850', textDecoration: 'none', fontSize: 14 }}
          >
            {label}
          </a>
        ))}
      </div>
    </footer>
  );
}
